// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"692":"643c373d","884":"a00a5689"}[chunkId] + ".chunk.js";
};